import { companyNameCharLimit } from "../constants/regex";
function isValidCompanyName(companyName: string | undefined) {
    /* if company name is undefined or empty or length is greater than companyNameCharLimit it is not valid
     * if three consecutive numbers are there then it is not valid
     * if the character is not alphanumeric or space, return false
     * total number of digits in the name cannot exceed 6 */

    if (
        !companyName ||
        companyName.length <= 0 ||
        companyName.length > companyNameCharLimit ||
        companyName.match(/[0-9]{3,}/g) ||
        companyName.match(/[^a-z0-9 ]/gi) ||
        companyName.match(/[0-9]/g)?.length! > 6
    ) {
        return false;
    }

    return true;
}

export { isValidCompanyName };
